/**
 * Vuex notifications module
 *
 * Generic notification store - no knowledge of specific features.
 * Any component can add notifications with custom action callbacks.
 */

const state = {
  notifications: []
}

const getters = {
  getNotifications: (state) => state.notifications,
  getUnreadCount: (state) => state.notifications.filter((n) => !n.read).length,
  hasUnread: (state) => state.notifications.some((n) => !n.read),
  getNotificationById: (state) => (id) => state.notifications.find((n) => n.id === id)
}

const mutations = {
  ADD_NOTIFICATION(state, notification) {
    // Prevent duplicate notifications with the same id
    const existingIndex = state.notifications.findIndex((n) => n.id === notification.id)
    if (existingIndex !== -1) {
      state.notifications.splice(existingIndex, 1, notification)
    } else {
      state.notifications.unshift(notification)
    }
  },

  MARK_AS_READ(state, id) {
    const index = state.notifications.findIndex((n) => n.id === id)
    if (index !== -1) {
      state.notifications.splice(index, 1, { ...state.notifications[index], read: true })
    }
  },

  MARK_ALL_AS_READ(state) {
    state.notifications = state.notifications.map((n) => ({ ...n, read: true }))
  },

  REMOVE_NOTIFICATION(state, id) {
    const index = state.notifications.findIndex((n) => n.id === id)
    if (index !== -1) {
      state.notifications.splice(index, 1)
    }
  },

  CLEAR_ALL(state) {
    state.notifications = []
  }
}

const actions = {
  addNotification({ commit }, payload) {
    const notification = {
      id: crypto.randomUUID(),
      read: false,
      createdAt: new Date().toISOString(),
      ...payload
    }
    commit('ADD_NOTIFICATION', notification)
    return notification.id
  },

  markAsRead({ commit }, id) {
    commit('MARK_AS_READ', id)
  },

  markAllAsRead({ commit }) {
    commit('MARK_ALL_AS_READ')
  },

  removeNotification({ commit }, id) {
    commit('REMOVE_NOTIFICATION', id)
  },

  clearAll({ commit }) {
    commit('CLEAR_ALL')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
